import { render } from "./EventAerialOverwatchBlog.vue?vue&type=template&id=bf0bfff0&scoped=true"
import script from "./EventAerialOverwatchBlog.vue?vue&type=script&lang=js"
export * from "./EventAerialOverwatchBlog.vue?vue&type=script&lang=js"

import "./EventAerialOverwatchBlog.vue?vue&type=style&index=0&id=bf0bfff0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf0bfff0"]])

export default __exports__